import { createSelector } from "reselect";
import find from "lodash/find";

const application = state => state.application;
const userIntegrationsSelector = state => state.session.user.profile.integrations;
const userApplicationsSelector = state => state.session.user.profile.applications;
const notificationPreferences = state => state.session.user.profile.appSettings?.notifications || {};
const orgId = state => state.session.organization.profile.orgId;
const userKeys = state => Object.keys(state.globalData.users);
const users = state => state.globalData.users;

export const getOrgMembers = createSelector(orgId, userKeys, users, (orgId, userKeys, users) => {
	return orgId ? userKeys.map(key => users[key]).filter(user => user.orgId === orgId) : undefined;
});

export const userApplicationArraySelector = createSelector(userApplicationsSelector, applications => {
	const appIds = applications.map(app => app.appId);
	return appIds;
});

export const userIntegrationsOfEntityTypeSelector = entityType => {
	return createSelector(userIntegrationsSelector, integrations =>
		integrations.filter(int => int.entityType === entityType && int.config.canView)
	);
};

export const userIntegrationByFeedIdSelector = feedId => {
	return createSelector(userIntegrationsSelector, integrations => find(integrations, int => int.feedId === feedId));
};

export const getCustomLabel = createSelector(userApplicationsSelector, application, (applications, application) => {
	const orgApplication = applications.find(app => app.appId === application.appId);
	return orgApplication?.overrideName && orgApplication?.orgAppName;
});

export const userIntsByEntityTypeSelector = createSelector(userIntegrationsSelector, integrations => entityType => {
	return integrations.filter(int => int.entityType === entityType);
});

export const checkUserIntPermissionByFeedId = createSelector(
	[userIntegrationsSelector],
	integrations => (feedId, permission) => {
		const userIntegration = find(integrations, int => int.feedId === feedId);
		const permissions = userIntegration?.permissions;

		return permissions?.includes(permission);
	}
);

export const checkUserAppPermissionByAppId = createSelector(
	[userApplicationsSelector],
	applications => (appId, permission = "manage") => {
		const userApp = find(applications, app => app.appId === appId);
		const permissions = userApp?.permissions;

		return permissions?.includes(permission);
	}
);